import { Pipe, PipeTransform } from '@angular/core';
import { TicketAirType } from "@afidium/ts-facade";

@Pipe({
    name: 'computeBookingLink'
})

export class ComputeBookingLinkPipe implements PipeTransform {
    public transform(ticket: TicketAirType): string {
        if (ticket && ticket.booking) {
            return `../../booking/${ticket.booking.code}`;
        }
        return null;
    }
}
